export default [{
    path: '/comic',
    component: resolve => require(['../../../view/find/Comic/comic.vue'], resolve),
}]


// WEBPACK FOOTER //
// ./src/router/find/comic/index.js